import { Box, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import { CardAddress } from "@/components/CardAddress";
import { CollapseSection } from "@/components/CollapseSection/CollapseSection";
import { DeliveryInformationsDispatchFile } from "./_partials";
import { DeliveryInformationsManualDispatch } from "./_partials/DeliveryInformationsManualDispatch";
import { type DeliveryInformationsBlocProps } from "./DeliveryInformationsBloc.types";

export const DeliveryInformationsBloc = ({
  orderItem,
}: DeliveryInformationsBlocProps) => {
  const { t } = useTranslate();

  const [isOpen, setIsOpen] = useState(false);
  const modificationsRequestAddresses =
    orderItem.sandboxItem.ModificationRequest?.modificationData?.to?.sandboxItemVersion[0].sandboxItemVersionDispatch.map(
      (e) => ({ ...e, ...e.address })
    ) || [];
  const itemAddresses =
    orderItem.sandboxItem.SandboxItemVersion[0].SandboxItemVersionDispatch;

  const toDisplayAddresses = [
    ...modificationsRequestAddresses,
    ...itemAddresses.map((e) => ({ ...e, isNew: false, isDeleted: false })),
  ];

  return (
    <Box bgColor="elevation.first" w="100%" p="sp-md" rounded="br-sm">
      <VStack gap="sp-md">
        <KdsText size="title-sm">
          {t("orderItem.deliveryInformations.title")}
        </KdsText>

        {orderItem.sandboxItem.dispatchType === "dispatchFiles" ? (
          <DeliveryInformationsDispatchFile orderItem={orderItem} />
        ) : (
          <DeliveryInformationsManualDispatch orderItem={orderItem} />
        )}

        <Box bgColor="surface.second" w="100%" p="sp-md" rounded="br-sm">
          <CollapseSection
            size="medium"
            isOpen={isOpen}
            onOpenChange={() => setIsOpen(!isOpen)}
            variant="transparent"
            title={t("orderItem.deliveryInformations.collapseSection.title")}
          >
            <VStack gap="sp-md">
              {toDisplayAddresses.flatMap((address) => {
                if (!address.address) {
                  return null;
                }

                return (
                  <div
                    key={address.address}
                    className="flex flex-col gap-sp-xs"
                  >
                    <CardAddress
                      addressDetails={address}
                      className="bg-white"
                      isNew={address?.isNew}
                      isDeleted={address?.isDeleted}
                    />
                  </div>
                );
              })}
            </VStack>
          </CollapseSection>
        </Box>
      </VStack>
    </Box>
  );
};
